import { AnimatePresence, motion } from "motion/react";
import { memo } from "react";
import {
  ExtendedNotificationType,
  NotificationItemGame,
  useFilteredNotifications,
} from "@/stores/notifications/notificationStore";
import { useVisibleNotifications } from "@/domains/notifications/hooks/useVisibleNotifications";
import NotificationsGameContainer from "@/domains/notifications/containers/NotificationsGameContainer";

function AnimatePresenceItem({ children }: { children: React.ReactNode }) {
  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 0 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{
        opacity: 0,
        x: -100,
        transition: { duration: 0.5, ease: "easeInOut" },
      }}
      transition={{ duration: 0.25, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}

const NOTIFICATION_TYPES = [ExtendedNotificationType.Game, ExtendedNotificationType.Npc];

function NotificationsBottomContainer() {
  const stack = useFilteredNotifications(NOTIFICATION_TYPES);
  const MAX_VISIBLE_NOTIFICATIONS = 4;

  const { visibleNotifications, removeNotification } = useVisibleNotifications(
    stack,
    MAX_VISIBLE_NOTIFICATIONS,
  );

  return (
    <div className="flex flex-col justify-end items-center p-4 pl-12 gap-4 w-[550px] h-[300px] overflow-hidden">
      <AnimatePresence>
        {visibleNotifications.reverse().map((item) => {
          switch (item.type) {
            case ExtendedNotificationType.Game:
              return (
                <AnimatePresenceItem key={item.id}>
                  <NotificationsGameContainer
                    item={item as NotificationItemGame}
                    onClick={() => removeNotification(item.id)}
                  />
                </AnimatePresenceItem>
              );

            // TODO: Implement NPC notifications
            case ExtendedNotificationType.Npc:
              return null;

            default:
              return null;
          }
        })}
      </AnimatePresence>
    </div>
  );
}

export default memo(NotificationsBottomContainer);
